import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f00559"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article-accent-bar" }, null, -1))
const _hoisted_4 = { class: "article-inner" }
const _hoisted_5 = { class: "article-footer" }
const _hoisted_6 = { class: "footer-tags" }
const _hoisted_7 = { class: "footer-center" }
const _hoisted_8 = { class: "footer-socials" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "right-pane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleSummary = _resolveComponent("ArticleSummary")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ChannelSummary = _resolveComponent("ChannelSummary")!
  const _component_BountySummary = _resolveComponent("BountySummary")!
  const _component_YoutubeSummary = _resolveComponent("YoutubeSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
        return (_openBlock(), _createBlock(_component_v_card, {
          key: article.title,
          class: "article"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ArticleSummary, { article: article }, null, 8, ["article"])
            ]),
            _createVNode(_component_v_divider, { class: "mt-2" }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: tag,
                    size: "small",
                    class: "tag-chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  elevation: "4",
                  onClick: ($event: any) => (_ctx.goToArticle(article))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Read More")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: icon,
                    icon: icon,
                    density: "comfortable",
                    variant: "text",
                    size: "small"
                  }, null, 8, ["icon"]))
                }), 128))
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _hoisted_9
    ]),
    _createVNode(_component_v_divider, {
      vertical: "",
      style: {"height":"100%"}
    }),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_ChannelSummary, { class: "right-pane-item" }),
      _createVNode(_component_BountySummary, { class: "right-pane-item" }),
      _createVNode(_component_YoutubeSummary, { class: "right-pane-item" })
    ])
  ]))
}